export default "__VITE_ASSET__6dc17883__"